/**
 * Standard modal footer: a Cancel-style button and a confirm button with a loading spinner.
 *
 * onConfirm         click handler; omit to make the confirm button submit the enclosing form
 * showConfirm       set false to render only the cancel button
 * isLoading         shows the spinner and disables both buttons
 * disabled          disables both buttons without the spinner
 * confirmDisabled   disables only the confirm button
 * children          extra leading content (e.g. a left-aligned button with `mr-auto`)
 */
function ModalActions({
  onCancel,
  cancelLabel = 'Cancel',
  onConfirm,
  confirmLabel = 'Save',
  confirmClassName = 'btn-primary w-24',
  showConfirm = true,
  isLoading = false,
  disabled = false,
  confirmDisabled = false,
  className = '',
  children,
}) {
  return (
    <div className={`flex flex-wrap justify-end gap-2 mt-8 ${className}`}>
      {children}
      <button
        type="button"
        className="btn btn-outline btn-sm focus:outline-none"
        disabled={isLoading || disabled}
        onClick={onCancel}
      >
        {cancelLabel}
      </button>
      {showConfirm && (
        <button
          type={onConfirm ? 'button' : 'submit'}
          className={`btn btn-sm focus:outline-none ${confirmClassName}`}
          disabled={isLoading || disabled || confirmDisabled}
          onClick={onConfirm}
        >
          {isLoading ? <span className="loading loading-spinner loading-xs" /> : confirmLabel}
        </button>
      )}
    </div>
  );
}

export default ModalActions;
